import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["g",{"transform":"translate(-110.2 -123.3)","key":"svg-g"}]]);